import Vue from 'vue';

Vue.component('project-listing', {
    data() {
        return {
            highlightedProjects: [],
            archivedProjects: [],
            selected: 'highlighted',
            filters: [],
            activeFilters: [],
            selectedFilters: [],
            searchQuery: null,
            searchActive: false,
            showFilters: false,
        };
    },

    props: {
        initialProjects: {
            type: Array,
        },
    },

    mounted() {
        this.highlightedProjects = this.filterHighlighted(
            this.initialProjects,
            true
        );

        this.archivedProjects = this.filterHighlighted(
            this.initialProjects,
            false
        );

        this.archivedProjects.forEach((item) => {
            item.relatedProducts.forEach((product) => {
                if (this.filters.indexOf(product.title) === -1) {
                    this.filters.push(product.title);
                }
            });
        });
    },

    computed: {
        filteredProjects: function () {
            if (!this.activeFilters.length && !this.searchQuery) {
                return this.archivedProjects;
            }

            if (!this.activeFilters.length && this.searchQuery) {
                return this.archivedProjects.filter((project) => {
                    return this.searchQuery
                        .toLowerCase()
                        .split(' ')
                        .every((v) => project.title.toLowerCase().includes(v));
                });
            }

            return this.archivedProjects.filter((project) => {
                let match = false;

                project.relatedProducts.forEach((product) => {
                    if (this.activeFilters.indexOf(product.title) !== -1) {
                        match = true;
                    }
                });

                return match;
            });
        },
    },

    methods: {
        /**
         * @param {array} projects
         * @param {boolean} highlighted
         * @returns array
         */
        filterHighlighted(projects, highlighted) {
            return projects.filter(
                (project) => project.highlighted === highlighted
            );
        },

        /**
         * @param {string} value
         */
        setActive(value) {
            this.selected = value;
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },

        clearFilters() {
            this.activeFilters = [];
            this.searchQuery = null;
            this.searchActive = false;
        },

        applyFilters() {
            this.showFilters = false;
            this.searchQuery = null;
            this.searchActive = false;
        },

        clearSearch() {
            this.searchQuery = null;
            this.searchActive = false;
        },

        setSearchActive() {
            this.searchActive = true;
        },

        /**
         *
         * @param {string} item
         */
        toggleFilterItem(item) {
            const itemIndex = this.activeFilters.indexOf(item);

            if (itemIndex === -1) {
                this.activeFilters.push(item);
            } else {
                this.activeFilters.splice(itemIndex, 1);
            }
        },
    },
});
